import React from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";

const AppRoutes = createBrowserRouter(
  [
    { path: "/geoLocation/:correlationId", element: <App /> },
    { path: "/dev/geoLocation/:correlationId", element: <App /> },
    { path: "/qa/geoLocation/:correlationId", element: <App /> },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  }
);

export default AppRoutes;
